import { render, staticRenderFns } from "./MarketDumpsterDetails.vue?vue&type=template&id=018aae5e&"
import script from "./MarketDumpsterDetails.vue?vue&type=script&lang=js&"
export * from "./MarketDumpsterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports